<template>
  <div
    id="mobileMenu"
    class="fc-offcanvas-open:translate-x-0 translate-x-full fixed top-0 end-0 transition-all duration-200 transform h-full w-full max-w-md z-50 bg-white border-s hidden"
  >
    <div class="flex flex-col h-full divide-y-2 divide-gray-200">
      <!-- Mobile Menu Topbar Logo (Header) -->
      <div class="p-6 flex items-center justify-between">
        <router-link to="/">
          <img :src="settingsStore.siteLogo" class="h-8" alt="Logo" />
        </router-link>
        <button data-fc-dismiss class="flex items-center px-2">
          <i class="fa-solid fa-xmark text-xl"></i>
        </button>
      </div>

      <!-- Mobile Menu Link List -->
      <div class="p-6 overflow-scroll h-full">
        <ul class="navbar-nav flex flex-col gap-2">
          <li
            class="nav-item"
            v-for="(menu, index) in menuStore.navbarMenu"
            :key="index"
          >
            <router-link
              v-if="!menu.IsMegaMenu"
              class="nav-link"
              :to="menu.Link"
            >
              {{ menu.Name }}
            </router-link>

            <div v-else>
              <a
                href="javascript:void(0)"
                class="nav-link"
                @click="toggleDropdown(index)"
              >
                {{ menu.Name }}
                <i
                  class="fa-solid fa-angle-down ms-auto align-middle transition-all"
                  :class="{ 'rotate-180': isDropdownOpen === index }"
                ></i>
              </a>
              <ul v-if="isDropdownOpen === index" class="mt-2 space-y-2">
                <li
                  class="nav-item mt-2"
                  v-for="(subMenu, subIndex) in menu.SubMenus"
                  :key="subIndex"
                >
                  <router-link class="nav-link" :to="subMenu.Link">
                    <span
                      class="bg-blue-600/10 flex justify-center items-center w-8 h-8 shadow rounded me-3"
                    >
                      <i
                        :class="subMenu.Icon"
                        class="fa text-blue-600 w-5 h-5 text-center"
                      ></i>
                    </span>
                    <div class="flex-grow-1">{{ subMenu.Name }}</div>
                  </router-link>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>

      <!-- Mobile Menu Footer -->
      <div class="p-6 flex items-center justify-center">
        <router-link
          :to="{ name: 'signin' }"
          class="bg-primary w-full text-white p-3 rounded flex items-center justify-center text-sm"
        >
          Üye Paneli
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useMenuStore } from "@/stores/menuStore";
import { useSettingsStore } from "@/stores/settingStore";

const menuStore = useMenuStore();
const settingsStore = useSettingsStore();
const isDropdownOpen = ref(null);

function toggleDropdown(index) {
  isDropdownOpen.value = isDropdownOpen.value === index ? null : index;
}
</script>

<style scoped>
.nav-item .nav-link {
  position: relative;
}

.nav-item .nav-link::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -5px;
  width: 100%;
  height: 2px;
  background-color: transparent;
  transition: background-color 0.3s ease;
}

.nav-item:hover .nav-link::after {
  background-color: #007bff;
}

.rotate-180 {
  transform: rotate(180deg);
}
</style>
